import { render, staticRenderFns } from "./AuthSSO.vue?vue&type=template&id=e6d90744"
import script from "./AuthSSO.vue?vue&type=script&lang=js"
export * from "./AuthSSO.vue?vue&type=script&lang=js"
import style0 from "./AuthSSO.vue?vue&type=style&index=0&id=e6d90744&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports